import { convertFromHTML } from 'draft-convert';
import { convertToRaw, RawDraftContentState } from 'draft-js';

const converterFunction = convertFromHTML({});

export function HTMLToDraft(html: string): RawDraftContentState {
  return convertToRaw(converterFunction(html));
}
